module.exports = __webpack_public_path__ + "img/checkin_step5.af21b1c2.jpg";